<template>
    <SOSlotBase :bg-white="true" :loading="isFetching && listMessage === 0" :container-name="'container-detail'">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar :page-title="'Detail WA Blast'" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-y-12">
                <div class="p-d-16">
                    <div class="f-bold f-18 f-c-black">
                        {{ detailHistory.nama }}
                    </div>
                    <div class="f-regular f-13 f-c-midgrey" v-if="isPreparing">
                        <span
                            class="spinner-border spinner-border-sm f-c-midgrey m-r-12"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        Menyiapkan blast...
                    </div>
                    <div class="f-regular f-13 f-c-midgrey" v-if="isRunning">
                        <span
                            class="spinner-border spinner-border-sm f-c-midgrey m-r-12"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        Sedang memproses ({{ detailHistory.message_detail.progress }}/{{ detailHistory.total }})...
                    </div>
                    <div class="f-regular f-13 f-c-midgrey" v-if="isPause">
                        Sedang dijeda
                    </div>
                    <div class="f-regular f-13 f-c-midgrey" v-if="isFinish">
                        {{ $moment(detailHistory.finished_at).format("dddd DD MMM YYYY HH:mm") }}
                    </div>
                    <div v-if="detailHistory.reason !== 'NoMoreData'">
                        <SOIconBase width="12" height="12" viewBox="0 0 18 17">
                            <template v-slot:icon>
                                <WarningTriangle1817 icon-fill="#964040" />
                            </template>
                        </SOIconBase>
                        <label class="m-d-0 f-12 f-regular f-c-red m-l-4">
                            {{ detailHistory.reason }}
                        </label>
                    </div>
                </div>

                <div class="p-d-16" v-if="validateAccess('whatsappBlast.update')">
                    <button
                        v-if="isPause"
                        class="btn btn-outline-midgrey f-semi f-14 f-c-midgrey m-r-8"
                        style="padding: 4px 8px"
                        :disabled="isFetching"
                        @click="mulai"
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.66638 4.2832V15.9499L15.833 10.1165L6.66638 4.2832Z" fill="#6F7287" />
                        </svg>
                        <span class="m-l-8">
                            {{ detailHistory.message_detail.progress > 0 ? "Lanjutkan" : "Mulai" }}
                        </span>
                    </button>
                    <button
                        v-if="isRunning"
                        class="btn btn-outline-midgrey f-semi f-14 f-c-midgrey m-r-8"
                        style="padding: 4px 8px"
                        :disabled="isFetching"
                        @click="jeda"
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5 15.8337H8.33333V4.16699H5V15.8337ZM11.6667 4.16699V15.8337H15V4.16699H11.6667Z"
                                fill="#6F7287"
                            />
                        </svg>
                        <span class="m-l-8">Jeda</span>
                    </button>
                    <button
                        v-if="!isFinish && !isPreparing"
                        class="btn btn-outline-midgrey f-semi f-14 f-c-midgrey"
                        style="padding: 4px 8px"
                        :disabled="isFetching"
                        @click="hentikan"
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 5H15V15H5V5Z" fill="#6F7287" />
                        </svg>
                        <span class="m-l-8">Hentikan</span>
                    </button>
                </div>

                <div class="p-d-16">
                    <div class="wa-blast-detail-box bg-grey p-x-12 p-y-12 position-relative">
                        <div class="row mx-0 m-d-8">
                            <div class="col-4 p-0 f-regular f-14 f-c-midgrey">
                                Tanggal blast:
                            </div>
                            <div class="col-8 p-0 f-regular f-14 f-c-black">
                                {{ $moment(detailHistory.created_at).format("DD MMM YYYY HH:mm") }}
                            </div>
                        </div>
                        <!-- <div class="row mx-0 m-d-8" id="perangkat">
                            <div class="col-4 p-0 f-regular f-14 f-c-midgrey">
                                Perangkat:
                            </div>
                            <div class="col-8 p-0 f-regular f-14 f-c-black nomore">
                                {{ getPerangkat }}
                            </div>
                        </div> -->
                        <div class="row mx-0 m-d-8" id="perangkat-detail">
                            <div class="col-4 p-0 f-regular f-14 f-c-midgrey">
                                Perangkat:
                            </div>
                            <div class="col-8 p-0">
                                <div v-for="(device, idx) in detailHistory.device" :key="`${idx}device-list`">
                                    <div class="f-regular f-14 f-c-black">
                                        <label class="m-d-0">
                                            {{ device.nama }}
                                            <span class="f-regular f-12 f-c-midgrey">
                                                ({{ device.country_code + device.number }})
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mx-0 m-d-8" id="template">
                            <div class="col-4 p-0 f-regular f-14 f-c-midgrey">
                                Template:
                            </div>
                            <div class="col-8 p-0 f-regular f-14 f-c-black nomore">
                                {{ getTemplate }}
                            </div>
                        </div>
                        <div class="row mx-0 m-d-8" id="template-detail" style="display: none">
                            <div class="col-4 p-0 f-regular f-14 f-c-midgrey">
                                Template:
                            </div>
                            <div class="col-8 p-0">
                                <div v-for="(template, idx) in detailHistory.template" :key="`${idx}-template-list`">
                                    <div class="f-regular f-14 f-c-black">
                                        {{ template.nama }}
                                    </div>
                                    <div v-if="validateAccess('whatsappBlast.template')" class="f-regular f-12 f-c-blue" @click="detailTemplate(template)">
                                        Lihat template
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mx-0">
                            <div class="col-4 p-0 f-regular f-14 f-c-midgrey">
                                Interval:
                            </div>
                            <div class="col-8 p-0 f-regular f-14 f-c-black">{{ detailHistory.interval }} detik</div>
                        </div>

                        <div class="position-absolute" style="bottom: 12px; right: 12px" @click="moreDetail">
                            <svg
                                id="chevron"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"
                                    fill="#6F7287"
                                />
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="p-d-16">
                    <div class="wa-blast-detail-box bg-grey p-x-12 p-y-12">
                        <div class="f-regular f-14 f-c-midgrey m-d-8">
                            Dikirim ke {{ detailHistory.total }} konsumen
                        </div>
                        <div class="d-flex" style="overflow-y: scroll">
                            <div
                                class="badge bg-white m-r-8"
                                :class="{ 'badge-active': statusBlast === 3 }"
                                @click="filterStatus(3)"
                                v-if="detailHistory.message_detail && detailHistory.message_detail.sukses > 0"
                            >
                                {{ detailHistory.message_detail.sukses }} Terkirim
                            </div>
                            <div
                                class="badge bg-white m-r-8"
                                :class="{ 'badge-active': statusBlast === 4 }"
                                @click="filterStatus(4)"
                                v-if="detailHistory.message_detail && detailHistory.message_detail.gagal > 0"
                            >
                                {{ detailHistory.message_detail.gagal }} Gagal
                            </div>
                            <div
                                class="badge bg-white m-r-8"
                                @click="filterStatus(2)"
                                :class="{ 'badge-active': statusBlast === 2 }"
                                v-if="detailHistory.message_detail && detailHistory.message_detail.diproses > 0"
                            >
                                {{ detailHistory.message_detail.diproses }} Sedang diproses
                            </div>
                            <div
                                class="badge bg-white m-r-8"
                                @click="filterStatus(1)"
                                :class="{ 'badge-active': statusBlast === 1 }"
                                v-if="detailHistory.message_detail && detailHistory.message_detail.queue > 0"
                            >
                                {{ detailHistory.message_detail.queue }} Belum diproses
                            </div>
                        </div>

                        <div class="f-regular f-12 m-t-8" v-if="countResendable">
                            <span class="f-c-midgrey">
                                Anda dapat mengirim ulang setiap pesan yang gagal. Atau
                            </span>
                            <span v-if="validateAccess('whatsappBlast.update')" class="f-c-blue" @click="doResendPerBlast(detailHistory.id)">
                                klik disini untuk mengirim ulang {{ countResendable }} pesan yang gagal sekaligus.
                            </span>
                        </div>
                    </div>
                </div>

                <div class="p-d-16">
                    <div style="position: relative" class="p-d-12">
                        <SOInputSearch
                            :value="searchKey"
                            :id="'filter-search'"
                            :autocomplete="'off'"
                            :delay-time="2000"
                            :do-searching="setSearchKey"
                        />
                    </div>
                </div>

                <div class="p-d-16">
                    <div class="wa-blast-detail-box">
                        <div class="row m-0 border-bottom p-x-12 p-y-8 wa-blast-detail-table-head">
                            <div class="col-6 p-0 f-bold f-14 f-c-midgrey">Konsumen</div>
                            <div class="col-6 p-0 f-bold f-14 f-c-midgrey">Status</div>
                        </div>
                        <div
                            class="row m-0 border-bottom p-x-12 p-y-8 align-items-center"
                            v-for="message in listMessage"
                            :key="message.id"
                        >
                            <div class="col-6 p-0" @click="showMessage(message.text)">
                                <div class="f-regular f-14 f-c-black">
                                    {{ message.nama_customer }}
                                </div>
                                <div class="f-regular f-12 f-c-midgrey">
                                    {{ message.nomor }}
                                </div>
                                <div class="f-regular f-c-blue f-12" @click="showMessage(message.text)">
                                    Lihat detail pesan
                                </div>
                            </div>
                            <div class="col-6 p-0">
                                <span
                                    class="m-r-4 wa-blast-detail-status"
                                    :class="{
                                        ready: message.status === 1,
                                        process: message.status === 2,
                                        success: message.status === 3,
                                        failed: message.status === 4,
                                    }"
                                >
                                    {{ statusPengirimanPesan(message.status) }}
                                </span>
                                <span
                                    class="wa-blast-detail-status resend"
                                    @click="validateAccess('whatsappBlast.update') && doResendPerId(message.id)"
                                    v-if="
                                        message.status === 4 &&
                                            !(
                                                message.status_text === 'BlastCancelled' ||
                                                message.status_text === 'Nomor tidak valid'
                                            )
                                    "
                                >
                                    Kirim ulang
                                    <SOIconBase width="10" height="10" viewBox="0 0 20 21">
                                        <template v-slot:icon>
                                            <Refresh2021 />
                                        </template>
                                    </SOIconBase>
                                </span>
                                <div class="f-regular f-12 f-c-midgrey">
                                    {{ $moment(message.created_at).format("DD MMM YYYY HH:mm") }}
                                </div>
                            </div>
                            <div
                                class="col-12 p-0 m-t-8 f-regular f-12 f-c-red"
                                v-if="message.status_text !== '' && message.status_text !== 'BlastCancelled'"
                            >
                                <SOIconBase width="14" height="14" viewBox="0 0 18 17">
                                    <template v-slot:icon>
                                        <WarningTriangle1817 icon-fill="#964040" />
                                    </template>
                                </SOIconBase>
                                <label class="m-d-0 f-12 f-regular f-c-red m-l-4">
                                    {{ message.status_text }}
                                </label>
                            </div>
                        </div>

                        <div
                            class="d-flex justify-content-center p-y-12"
                            id="load-more-message"
                            style="display: none !important;"
                        >
                            <span
                                class="spinner-border spinner-border-sm f-c-midgrey m-r-12"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            <span class="f-regular f-14 f-c-midgrey">Memuat...</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "./../store/state";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputSearch from "@/so-components/global/input/SOInputSearch";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import Refresh2021 from "@/so-components/global/icons/iconPacks/Refresh2021.vue";
import WarningTriangle1817 from "@/so-components/global/icons/iconPacks/WarningTriangle1817.vue";

export default {
    name: "WABlastDetail",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOInputSearch,
        SOIconBase,
        Refresh2021,
        WarningTriangle1817,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            detailHistory: "detailHistory",
            listMessage: "listMessage",
            paginationMessage: "paginationMessage",
        }),
        getTemplate() {
            let arr = [];
            let template = this.detailHistory?.template || [];
            template.forEach((v) => {
                arr = arr.concat(v.nama);
            });
            return arr.join(", ");
        },
        isPause() {
            return this.detailHistory.finished_at === null && this.detailHistory.running === 0;
        },
        isPreparing() {
            return this.detailHistory.finished_at === null && this.detailHistory.running === 2;
        },
        isRunning() {
            return this.detailHistory.finished_at === null && this.detailHistory.running === 1;
        },
        isFinish() {
            return this.detailHistory.finished_at !== null;
        },
        countResendable() {
            return this.listMessage.filter(
                (v) => v.status === 4 && !(v.status_text === "BlastCancelled" || v.status_text === "Nomor tidak valid")
            ).length;
        },
    },
    data() {
        return {
            socketKey: "wablast.job.countprocessedmessage.",

            id: "",
            searchKey: "",
            statusBlast: null,
            chevronRotate: false,
        };
    },
    sockets: {
        connect: () => {
            console.log("socket connected");
        },
    },
    mounted() {
        this.id = this.$route.params.id;
        this.fetchDetailHistory(this.id);
        this.fetchListMessage({ id: this.id });
        this.scroll();
        setTimeout(() => {
            this.subscribeIdBlast(this.id);
            this.subscribeStatusBlast(this.id);
        }, 1000);
    },
    methods: {
        ...mapActions({
            fetchDetailHistory: `${moduleName}/fetchDetailHistory`,
            fetchListMessage: `${moduleName}/fetchListMessage`,
            setFetching: `${moduleName}/setFetching`,

            startBlast: `${moduleName}/startBlast`,
            pauseBlast: `${moduleName}/pauseBlast`,
            cancelBlast: `${moduleName}/cancelBlast`,

            resendPerBlast: `${moduleName}/resendPerBlast`,
            resendPerId: `${moduleName}/resendPerId`,

            resetPagination: `${moduleName}/resetPagination`,
            resetListHistory: `${moduleName}/resetListHistory`,
        }),
        back() {
            // this.resetListHistory()
            // this.resetPagination()
            this.$router.back();
        },
        showMessage(val) {
            this.$router.push({ name: "wa_blast.detail.preview_message", params: { msg: val ? val : "WA Blast" } });
        },
        statusPengirimanPesan(status) {
            let res;
            switch (status) {
                case 1:
                    res = "Belum diproses";
                    break;
                case 2:
                    res = "Sedang diproses";
                    break;
                case 3:
                    res = "Terkirim";
                    break;
                case 4:
                    res = "Gagal";
                    break;
                default:
                    break;
            }
            return res;
        },
        async setSearchKey(input) {
            this.serachKey = input;
            await this.doSearch();
        },
        async filterStatus(status) {
            if (this.statusBlast === status) {
                this.statusBlast = null;
            } else {
                this.statusBlast = status;
            }
            await this.doSearch();
        },
        async doSearch() {
            await this.$store.commit(`${moduleName}/resetPaginationMessage`);
            await this.$store.commit(`${moduleName}/resetListMessage`);
            await this.fetchListMessage({ id: this.id, key: this.serachKey, status: this.statusBlast });
        },
        moreDetail() {
            $("#perangkat").slideToggle();
            $("#perangkat-detail").slideToggle();
            $("#template").slideToggle();
            $("#template-detail").slideToggle();
            if (this.chevronRotate) {
                $("#chevron").css({ transform: "rotate(0deg)" });
                this.chevronRotate = false;
            } else {
                $("#chevron").css({ transform: "rotate(180deg)" });
                this.chevronRotate = true;
            }
        },

        // scrolled data
        async fetchScrolledData() {
            $("#load-more-message").addClass("d-flex");
            await this.fetchListMessage({ id: this.id, key: this.serachKey, status: this.statusBlast });
            setTimeout(() => {
                this.$store.commit("helper/setScrollCalled", false);
                $("#load-more-message")
                    .removeClass("d-flex")
                    .hide();
            }, 3000);
        },
        scroll() {
            window.onscroll = async () => {
                let payload = {
                    idLoadMore: "load-more-message",
                    container: "container-detail",
                    pagination: this.paginationMessage,
                    callback: this.fetchScrolledData,
                };
                await this.$store.dispatch("helper/scroll", payload);
            };
        },

        detailTemplate(template) {
            this.$router.push({
                name: "wa_blast.detail.template",
                params: {
                    id: template.id,
                    title: template.nama,
                    mode: 1,
                },
            });
        },
        mulai() {
            let form = new FormData();
            form.append("idblast", this.id);
            this.startBlast(form)
                .then((response) => {
                    if (response.data !== undefined) {
                        let { code, status, msg, data } = response.data;

                        if (status && code === 200) {
                            this.$toast.success(msg);
                            this.detailHistory.running = 1;
                            this.subscribeIdBlast(this.id);
                            this.subscribeStatusBlast(this.id);
                            this.setFetching(false);
                        } else {
                            this.setFetching(false);
                            this.$toast.error(msg);
                        }
                    } else {
                        this.setFetching(false);
                        this.$toast.error(response);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
        jeda() {
            this.$router.push({ name: "wa_blast.detail.jeda", params: { id: this.id } });
        },
        hentikan() {
            this.$router.push({ name: "wa_blast.detail.hentikan", params: { id: this.id } });
        },

        doResendPerBlast(id) {
            let form = new FormData();
            form.append("idblast", id);
            this.resendPerBlast(form)
                .then((response) => {
                    if (response.data !== undefined) {
                        let { code, status, msg, data } = response.data;

                        if (status && code === 200) {
                            this.setFetching(false);
                            this.afterResend(id);
                            this.subscribeStatusBlast(id);
                        } else {
                            this.setFetching(false);
                            this.$toast.error(msg);
                        }
                    } else {
                        this.setFetching(false);
                        this.$toast.error(response);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
        doResendPerId(id) {
            let form = new FormData();
            form.append("idblast_data", id);
            this.resendPerId(form)
                .then((response) => {
                    if (response.data !== undefined) {
                        let { code, status, msg, data } = response.data;

                        if (status && code === 200) {
                            this.setFetching(false);
                            this.afterResend(this.id);
                        } else {
                            this.setFetching(false);
                            this.$toast.error(msg);
                        }
                    } else {
                        this.setFetching(false);
                        this.$toast.error(response);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
        afterResend(id) {
            this.$store.commit(`${moduleName}/resetPaginationMessage`);
            this.$store.commit(`${moduleName}/resetListMessage`);
            this.fetchDetailHistory(id);
            this.fetchListMessage({ id: id });
            setTimeout(() => {
                this.subscribeIdBlast(this.id);
            }, 1000);
        },

        updateProgressBlast(id, report) {
            this.detailHistory.message_detail.progress = report;

            if (this.detailHistory.total === parseInt(this.detailHistory.message_detail.progress)) {
                this.detailHistory.running = 0;
                this.detailHistory.finished_at = this.$moment();
            }
        },
        subscribeIdBlast(id) {
            let { sukses, gagal } = this.detailHistory.message_detail;
            this.detailHistory.message_detail.progress = sukses + gagal;
            this.sockets.subscribe(this.socketKey + id, async (report) => {
                await this.updateProgressBlast(id, parseInt(report));
            });
        },
        unsubscribeIdBlast(id) {
            this.sockets.unsubscribe(this.socketKey + id);
        },
        subscribeStatusBlast(id) {
            this.sockets.subscribe(`wablast.job.status.${id}`, (status) => {
                if (status === "BlastDone") {
                    this.detailHistory.finished_at = this.$moment().format("YYYY-MM-DD HH:mm:ss");
                    this.sockets.unsubscribe(`wablast.job.status.${id}`);
                    this.$store.commit(`${moduleName}/resetPaginationMessage`);
                    this.$store.commit(`${moduleName}/resetListMessage`);
                    this.fetchDetailHistory(this.id);
                    this.fetchListMessage({ id });
                } else if (status === "SetupDone") {
                    this.detailHistory.finished_at = null;
                    this.detailHistory.running = 0;
                } else if (status === "BlastStart") {
                    this.detailHistory.finished_at = null;
                    this.detailHistory.running = 1;
                }
            });
        },
    },
    beforeDestroy() {
        this.$store.commit(`${moduleName}/resetPaginationMessage`);
        // this.$store.commit(`${moduleName}/resetListMessage`)
        this.unsubscribeIdBlast(this.id);
    },
};
</script>

<style scoped>
.wa-blast-detail-box {
    border-radius: 4px;
    border: 1px solid #ededed;
}

.wa-blast-detail-table-head {
    background: #f2f5f7;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}

.wa-blast-detail-status {
    padding: 2px 4px;
    font-size: 12px;
    border-radius: 4px;
}

.wa-blast-detail-status.success {
    color: #40964c;
    background: #e8fcee;
}

.wa-blast-detail-status.failed {
    color: #964040;
    background: #fff1f1;
}

.wa-blast-detail-status.process {
    color: #c29500;
    background: #fff8e1;
}

.wa-blast-detail-status.ready {
    color: #6f7287;
    background: #ededed;
}

.wa-blast-detail-status.resend {
    border: 1px solid #ededed;
    color: #206cff;
    background: white;
}

.badge.badge-active {
    background: #206cff !important;
    color: white !important;
}
</style>
